import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { isGoogleAnalyticsEnabled } from './services/analytics';
import Routes from './routes';
import Providers from './context/Providers';
import SuspenseWrapper from './components/modules/SuspenseWrapper/SuspenseWrapper';
if (window.config.environment !== 'local') {
    Sentry.init({
        dsn: 'https://5ba17a4a14cd4af0ab4cbaa704b91735@o177761.ingest.sentry.io/5650811',
        environment: window.config.environment,
    });
    if (window.config.session_user) {
        Sentry.configureScope((scope) => {
            scope.setUser({
                id: String(window.config.session_user?.id),
            });
        });
    }
}
if (module && module.hot) {
    module.hot.accept();
    module.hot.addStatusHandler((status) => {
        if (status === 'prepare')
            console.clear();
    });
}
const domNode = document.getElementById('container');
const root = createRoot(domNode);
function toggleGoogleAnalytics() {
    if (window.config.ga_measurement_id) {
        const gaDisableKey = `ga-disable-${window.config.ga_measurement_id}`;
        window[gaDisableKey] = !isGoogleAnalyticsEnabled();
    }
}
toggleGoogleAnalytics();
document.addEventListener('consentCookieChange', toggleGoogleAnalytics);
root.render(React.createElement(SuspenseWrapper, null,
    React.createElement(Providers, null,
        React.createElement(Router, null,
            React.createElement(Routes, null)))));
